/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { customStyles } from '../../components/datatable/customStyles';
import toast from 'react-hot-toast';
import { clients_services } from '../../services/clients_services';
import moment from 'moment';

const ScanClientHistory = () => {
    // Navigations
    const navigate = useNavigate()
    const home = () => {
        navigate('/company/dashboad');
    };
    const list_scanhistory = () => {
        navigate('/company/list/scanhistory');
    };

    // declaration 
    const [scanHistory, setScanHistory] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [sortOrder, setSortOrder] = useState('');
    const [sortFilter, setSortFilter] = useState('');


    // get all client function
    const getAllScanHistory = () => {
        clients_services.getAllScanHistory()
            .then((res) => {
                // console.log("scanHistoryRes : ", res.data.storyScan )
                setScanHistory(res.data.storyScan
                )
            })
            .catch((err) => {
                console.log(err)
                if (err.response) {
                    if (err.response.status === 400) {
                        navigate("/auth/loginCompany");
                    }
                    if (err.response.status === 404) {
                        toast("Utilisateur introuvable")
                    }
                    if (err.response.status === 403) {
                        toast.error("Erreur lors de la récupération des clients");
                    }
                    if (err.response.status === 500) {
                        toast.error("Erreur d'exécution dans l'application , veillez vous reconnecter.")
                    }
                }
            }
            )
    }

    // Retrieve the clients when the component is mounted and each time the sorting/filtering criteria change
    useEffect(() => {
        getAllScanHistory();
    }, [sortOrder, sortFilter]);

    const transformedData = filteredData.map((row) => ({
        ...row,
        showNbVisite: row.Structure.typeInterventionId === 1,
        showQuantite: row.Structure.typeInterventionId === 2,
    }));

    // Définir les colonnes du tableau
    const columns = [
        {
            name: '#',
            selector: (row, index) => index + 1,
            width: '60px',
            sortable: true,
        },
        {
            name: 'Nom',
            selector: (row) => row.nomClient,
            sortable: true,
        },
        {
            name: 'Prénom',
            selector: (row) => row.prenomClient,
            sortable: true,
        },
        {
            name: 'Nb.Visite',
            selector: (row) => row.nbrVisiteClient,
            sortable: true,
            omit: !transformedData.some((row) => row.showNbVisite),
        },
        {
            name: 'Quantité',
            selector: (row) => row.nbrVisiteClient,
            sortable: true,
            omit: !transformedData.some((row) => row.showQuantite),
        },
        {
            name: 'Date',
            selector: (row) => moment(row.date).format('YYYY-MM-DD'),
            sortable: true,
        },
        {
            name: 'Heure',
            selector: (row) => row.heure,
            sortable: true,
        },
        {
            name: 'Localisation',
            selector: (row) => row.localisationClient,
            sortable: true,
        },
    ];

    // Function to filter and sort client based on current status
    const getScanHistorySortAdnfilter = () => {
        let scanHistoryFilters = scanHistory

        // sort clients info
        scanHistoryFilters.sort((a, b) => {
            if (sortOrder === 'desc') {
                if (sortFilter === 'nom') {
                    return b.nomClient.localeCompare(a.nomClient);
                } else if (sortFilter === 'prenom') {
                    return b.prenomClient.localeCompare(a.prenomClient);
                } else if (sortFilter === 'localisation') {
                    return b.localisationClient.localeCompare(a.localisationClient);
                } 
            } else {
                if (sortFilter === 'nom') {
                    return a.nomClient.localeCompare(b.nomClient);
                } else if (sortFilter === 'prenom') {
                    return a.prenomClient.localeCompare(b.prenomClient);
                } else if (sortFilter === 'localisation') {
                    return a.localisationClient.localeCompare(b.localisationClient);
                }
            }
        });

        return scanHistoryFilters
    }

    // Mettre à jour les données filtrées et triées chaque fois que l'un des états change
    useEffect(() => {
        const sortedFilteredScanHistory = getScanHistorySortAdnfilter();
        setFilteredData(sortedFilteredScanHistory);
    }, [scanHistory, sortOrder, sortFilter]);

    // Filtrer les données en fonction du texte de recherche
    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchText(value);
        const filtered = getScanHistorySortAdnfilter().filter(item => {

            return (
                item.nomClient.toLowerCase().includes(value.toLowerCase()) ||
                item.prenomClient.toLowerCase().includes(value.toLowerCase()) ||
                item.localisationClient.toLowerCase().includes(value.toLowerCase())
            );
        });
        setFilteredData(filtered);  
    };

    // Function to format the current date and time as 'YYYY-MM-DD_HH-MM'
    const getFormattedDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}_${hours}-${minutes}`;
    };

    return (
        <div>
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Gestion des clients</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item link"><a onClick={home}>Acceuil</a></li>
                                    <li className="breadcrumb-item link"><a onClick={list_scanhistory}>Clients</a></li>
                                    <li className="breadcrumb-item active">Historique du scan </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title"><i className="fas fa-list mr-2 text-light titleIcon"></i>Historique du scan</h3>

                                            <div className="" style={{ position: 'relative', float: 'right' }}>

                                                <button className="btn btn-light text-secondary shadow btn-xs" onClick={home} title='Retour au tableau de bord'>
                                                    <i className="mr-1 fas fa-arrow-left" />
                                                    Rétour
                                                </button>
                                            </div>
                                        </div>

                                        <div className="card-body">
                                            <form className="form filtre align-items-center d-flex justify-content-between flex-wrap" >
                                                <div>
                                                    <label htmlFor="orderOption"> Trier par..</label>
                                                    <select className="optionSelect" value={sortOrder} name={sortOrder} onChange={(e) => setSortOrder(e.target.value)} id='orderOption'>
                                                        <option value="" selected >---</option>
                                                        <option value="asc">Ordre croissant</option>
                                                        <option value="desc">Ordre décroissant</option>
                                                    </select>
                                                </div>

                                                <div>
                                                    <label htmlFor="filterOption"> Filtrer par..</label>
                                                    <select className="optionSelect ml-2" value={sortFilter} name={sortFilter} onChange={(e) => setSortFilter(e.target.value)} id='filterOption'>
                                                        <option value="" selected >---</option>
                                                        <option value="nom">Nom</option>
                                                        <option value="prenom">Prénom</option>
                                                        <option value="localisation">Localisation</option>
                                                    </select>
                                                </div>

                                                <div className="">
                                                    <input
                                                        className='search optionSelect'
                                                        type="text"
                                                        placeholder="Rechercher..."
                                                        value={searchText}
                                                        onChange={handleSearch}
                                                    />
                                                </div>
                                            </form>
                                            <DataTable
                                                columns={columns}
                                                data={filteredData}
                                                striped
                                                highlightOnHover
                                                customStyles={customStyles}
                                                pagination
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div >
    );
};

export default ScanClientHistory;